import { render } from "./UserMessagesView.vue?vue&type=template&id=576ea176&scoped=true"
import script from "./UserMessagesView.vue?vue&type=script&lang=js"
export * from "./UserMessagesView.vue?vue&type=script&lang=js"

import "./UserMessagesView.vue?vue&type=style&index=0&id=576ea176&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576ea176"]])

export default __exports__